var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.25C3.35786 15.25 0 11.8921 0 7.75C0 3.60786 3.35786 0.25 7.5 0.25C11.6421 0.25 15 3.60786 15 7.75C14.9955 11.8903 11.6403 15.2455 7.5 15.25ZM7.488 13.75H7.5C10.8125 13.7467 13.4957 11.0595 13.494 7.747C13.4923 4.43447 10.8065 1.75 7.494 1.75C4.18146 1.75 1.49566 4.43447 1.494 7.747C1.49234 11.0595 4.17546 13.7467 7.488 13.75ZM4.8855 9.898L3.825 8.8375L7.5375 5.125L11.25 8.8375L10.1895 9.89725L7.5375 7.246L4.88625 9.898H4.8855Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperWhite);
export default __webpack_public_path__ + "static/media/upperWhite.02a742dd92188e117350163279c3dfe9.svg";
export { ForwardRef as ReactComponent };